import Phaser from 'phaser';
import { AUDIO_FILES } from '../audio/Sfx';
import { createPixelFont } from '../ui/pixelFont';

/**
 * Loads the few files the prototype uses, builds the pixel font, then opens the lab (the hub).
 * In dev builds a `?room=` (earth, boss, test) or `?planet=` option goes straight to the
 * platforming instead.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  preload(): void {
    for (const [key, path] of Object.entries(AUDIO_FILES)) this.load.audio(key, path);
  }

  create(): void {
    createPixelFont(this);
    const params = new URLSearchParams(window.location.search);
    const shortcut = import.meta.env.DEV && (params.has('room') || params.has('planet'));
    this.scene.start(shortcut ? 'Play' : 'Lab');
  }
}
